module.exports = __webpack_public_path__ + "img/road-construction.5dd568d.jpg";